import React from 'react'
import styled from 'styled-components'
import { Row, Col, Layout } from 'antd'
import { PrimaryButton } from 'Components/Shared/Button'
const { Footer } = Layout

type Props = {
  onCancel: () => void
  onSave: () => void
}

const AddAfterImgFooter: React.FC<Props> = ({ onCancel, onSave }) => {
  return (
    <Footer className="detail-page-footer">
      <FooterContent>
        <Row type="flex" justify="space-between" align="middle">
          <Col>
            <Button>
              <PrimaryButton
                text="ยกเลิก"
                onClick={onCancel}
                btnType="Cancel"
              />
            </Button>
          </Col>
          <Col>
            <Button>
              <PrimaryButton text="บันทึก" onClick={onSave} />
            </Button>
          </Col>
        </Row>
      </FooterContent>
    </Footer>
  )
}

const FooterContent = styled.div`
  max-width: 1110px;
  margin: 0 auto;
  color: #000;
  font-size: 20px;
  padding-right: 20px;
`

const Button = styled.div`
  width: 160px;
`

export default AddAfterImgFooter
